<app-programtitle title="Find whether a given number is odd or even"></app-programtitle>

<p> Write a program to find whether a given number is odd or even number.</p>

<p>An even number is divisible (reminder) by 2. To find out the reminder, we use the python's % operator.</p>
<app-editor code="{{program}}"> </app-editor>

<app-exercisetitle title="Exercise"> </app-exercisetitle>
<p> Write a program to find whether a given number is divisible by 10</p>